export const AREA_VENDA_FORNECEDOR_LOAD = "AREA_VENDA_FORNECEDOR_LOAD";
